module.exports = require('./helpers/bundle-url').getBundleURL('esHYc') + "logo.c51670a8.svg";